var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const defaultSettings = {
  arrows: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 0
};
const getSelectedDimension = (responsive, windowWidth) => {
  const responsiveCandidate = responsive.find(
    (item) => item.breakpoint > windowWidth
  );
  const { config } = responsiveCandidate != null ? responsiveCandidate : {};
  if (!config) {
    return;
  }
  const { width } = config;
  if (typeof width !== "number") {
    return __spreadProps(__spreadValues({}, config), { width: windowWidth });
  }
  return config;
};
const getSettings = (overrides = {}) => {
  return __spreadValues(__spreadValues({}, defaultSettings), overrides);
};

export { defaultSettings, getSelectedDimension, getSettings };
//# sourceMappingURL=bundle.esm2.js.map
